/* ====================================
   FIRE TERMINATOR NZ - THEME JAVASCRIPT
   ==================================== */

// Mobile Menu Toggle
(function() {
  const menuToggle = document.getElementById('mobileMenuToggle');
  const navMenu = document.getElementById('navMenu');

  if (menuToggle && navMenu) {
    menuToggle.addEventListener('click', function() {
      navMenu.classList.toggle('active');
    });

    // Close menu when clicking on a link
    navMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', function() {
        navMenu.classList.remove('active');
      });
    });
  }
})();

// Header Scroll Effect
(function() {
  const header = document.getElementById('header');
  let lastScrollTop = 0;

  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 100) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    });
  }
})();

// FAQ Accordion
(function() {
  const faqQuestions = document.querySelectorAll('[data-faq-toggle]');

  faqQuestions.forEach(question => {
    question.addEventListener('click', function() {
      const answer = this.nextElementSibling;

      // Close other answers
      faqQuestions.forEach(q => {
        if (q !== this) {
          const otherAnswer = q.nextElementSibling;
          q.classList.remove('active');
          if (otherAnswer) {
            otherAnswer.classList.remove('active');
            otherAnswer.style.display = 'none';
          }
        }
      });

      // Toggle current answer
      this.classList.toggle('active');
      if (answer) {
        answer.classList.toggle('active');
        answer.style.display = answer.classList.contains('active') ? 'block' : 'none';
      }
    });
  });
})();

// Cart Icon Update
(function() {
  const cartIcon = document.getElementById('cartIcon');

  if (cartIcon) {
    // Update cart count on page load
    updateCartCount();

    // Listen for cart updates
    document.addEventListener('cart:update', updateCartCount);
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const badge = cartIcon.querySelector('.cart-badge');
        const count = cart.item_count;

        if (count > 0) {
          if (badge) {
            badge.textContent = count;
          } else {
            const newBadge = document.createElement('span');
            newBadge.className = 'cart-badge';
            newBadge.textContent = count;
            cartIcon.appendChild(newBadge);
          }
        } else if (badge) {
          badge.remove();
        }
      });
  }
})();

// AJAX Add to Cart
(function() {
  const forms = document.querySelectorAll('form[action="/cart/add"]');

  forms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      const formData = new FormData(this);
      const data = Object.fromEntries(formData);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(() => {
          // Show success message
          showNotification('Added to cart!', 'success');

          // Update cart count
          document.dispatchEvent(new Event('cart:update'));
        })
        .catch(error => {
          console.error('Error:', error);
          showNotification('Failed to add to cart', 'error');
        });
    });
  });

  function showNotification(message, type = 'info') {
    const notification = document.createElement('div');
    notification.className = `notification notification-${type}`;
    notification.textContent = message;
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${type === 'success' ? '#4caf50' : '#f44336'};
      color: white;
      padding: 1rem 1.5rem;
      border-radius: 4px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      z-index: 1000;
      animation: slideInRight 0.3s ease;
    `;

    document.body.appendChild(notification);

    setTimeout(() => {
      notification.style.animation = 'slideInRight 0.3s ease reverse';
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }
})();

// Smooth Scroll for Anchor Links
(function() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href === '#') return;

      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
})();

// Scroll Animations
(function() {
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fade-in');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.feature-card, .use-case-card, .step-card').forEach(el => {
    observer.observe(el);
  });
})();

// Product Thumbnail Gallery
(function() {
  const thumbnails = document.querySelectorAll('.thumbnail');
  const mainImage = document.querySelector('.main-image');

  if (thumbnails.length && mainImage) {
    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', function() {
        const newSrc = this.getAttribute('data-src');
        mainImage.src = newSrc;

        thumbnails.forEach(t => t.style.borderColor = 'transparent');
        this.style.borderColor = 'var(--primary-color)';
      });
    });
  }
})();

// Variant Selector
(function() {
  const variantSelect = document.getElementById('variant');
  const productVariantInput = document.getElementById('product-variant');

  if (variantSelect && productVariantInput) {
    variantSelect.addEventListener('change', function() {
      productVariantInput.value = this.value;
    });
  }
})();

// Cart Quantity Updates
(function() {
  const quantityInputs = document.querySelectorAll('.quantity-column input');

  quantityInputs.forEach(input => {
    input.addEventListener('change', function() {
      const form = this.closest('form');
      if (form) {
        form.submit();
      }
    });
  });
})();

// Console log for debugging (remove in production)
console.log('Fire Terminator NZ Theme loaded successfully');
